module.exports = __webpack_public_path__ + "img/R+logo.1d90485e.png";